/**
 * Platform detection helpers.
 * Tauri must be detected BEFORE Capacitor because Tauri's webview
 * may also expose window.Capacitor.
 */
export const isTauri = () => !!window.__TAURI_INTERNALS__;
export const isCapacitor = () => !isTauri() && !!window.Capacitor?.isNativePlatform?.();
export const isDesktop = () => isTauri();
export const isWeb = () => !isTauri() && !isCapacitor();
